import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import Users from "../pages/Contacts/Users/contacts-list";
import NotificationList from "../pages/Notifications/notification-list";
import SendNotification from "../pages/Notifications/send-notification";
import NotificationTitles from "../pages/Notifications/notification-titles";
import AnalyticsDashboard from "../pages/Analytics/analytics-dashboard";

import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/users", component: <Users /> },
  { path: "/notifications", component: <NotificationList /> },
  { path: "/send-notification", component: <SendNotification /> },
  { path: "/notification-titles", component: <NotificationTitles /> },
  { path: "/analytics", component: <AnalyticsDashboard /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
];

export { authProtectedRoutes, publicRoutes };
